import api from './api';

export type HeroBannerMediaType = 'image' | 'video';

export interface HeroBannerConfig {
  text: string;
  visible: boolean;
  scheduledFrom: string | null;
  scheduledUntil: string | null;
  mediaUrl: string | null;
  mediaType: HeroBannerMediaType | null;
  mascotUrl: string | null;
  overlayLine1: string | null;
  overlayLine2: string | null;
  overlayFontFamily: string | null;
  overlayLine1Color: string | null;
  overlayLine2Color: string | null;
  showMascot: boolean;
  showOverlay: boolean;
  showAnnouncementCard: boolean;
  mascotPosX: number;
  mascotPosY: number;
  overlayPosX: number;
  overlayPosY: number;
  announcementPosX: number;
  announcementPosY: number;
  mascotScale: number;
  overlayLine1Scale: number;
  overlayLine2Scale: number;
  updatedBy: string | null;
  updatedAt: string;
}

export interface UpdateHeroBannerPayload {
  text?: string;
  visible?: boolean;
  scheduledFrom?: string | null;
  scheduledUntil?: string | null;
  clearMedia?: boolean;
  clearMascot?: boolean;
  overlayLine1?: string;
  overlayLine2?: string;
  overlayFontFamily?: string;
  overlayLine1Color?: string;
  overlayLine2Color?: string;
  showMascot?: boolean;
  showOverlay?: boolean;
  showAnnouncementCard?: boolean;
  mascotPosX?: number;
  mascotPosY?: number;
  overlayPosX?: number;
  overlayPosY?: number;
  announcementPosX?: number;
  announcementPosY?: number;
  mascotScale?: number;
  overlayLine1Scale?: number;
  overlayLine2Scale?: number;
}

export const heroBannerService = {
  async get(): Promise<HeroBannerConfig> {
    const { data } = await api.get<HeroBannerConfig>('/hero-banner');
    return data;
  },

  async update(payload: UpdateHeroBannerPayload): Promise<HeroBannerConfig> {
    const { data } = await api.patch<HeroBannerConfig>('/hero-banner', payload);
    return data;
  },

  async uploadMedia(file: File): Promise<HeroBannerConfig> {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post<HeroBannerConfig>('/hero-banner/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },

  async uploadMascot(file: File): Promise<HeroBannerConfig> {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post<HeroBannerConfig>('/hero-banner/upload-mascot', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  },
};
